import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Section1.css";
import { useNavigate } from "react-router-dom";

import office from "../Images/office.png";
import office1 from "../Images/office1.png";
import office2 from "../Images/office2.png";
import office3 from "../Images/office3.png";

const slides = [
  {
    title: "ITIN Application Assistance",
    desc: "Get accurate, hassle-free ITIN support with expert guidance from start to finish.",
    img: office,
  },
  {
    title: "Federal & State Tax Filing",
    desc: "Experience stress-free tax filing with trusted professionals maximizing your benefits.",
    img: office1,
  },
  {
    title: "FBAR & FATCA Compliance",
    desc: "Stay fully compliant with international reporting while avoiding costly penalties.",
    img: office2,
  },
  {
    title: "Business & Individual Tax Planning",
    desc: "Plan ahead with personalized strategies designed to reduce your tax burden effectively.",
    img: office3,
  },
];

const Section1 = () => {
  const navigate = useNavigate();

  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 3000 }}
      pagination={{ clickable: true }}
      loop={true}
      className="etx-hero-swiper"
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <div className="etx-slide-wrapper">
            <img src={slide.img} alt={slide.title} className="etx-slide-image" />

            <div className="etx-slide-overlay"></div>

            <div className="etx-slide-text">
              <h2>{slide.title}</h2>
              <p>{slide.desc}</p>

              {/* ⭐ REGISTER NOW BUTTON WITH NAVIGATION */}
              <button
                className="etx-register-btn"
                onClick={() => navigate("/signup")}
              >
                Register Now
              </button>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Section1;
